import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { usePrefs, useLabels } from 'wsm-common-data';
import filterVehiclesWithoutInventory from '../utils/filterVehiclesWithoutInventory';
import { groupUniqueVehicles } from '../utils/groupUniqueVehicles';
import { inventoryCountsSelector } from '../server/selectors';
import { addModelInv } from '../utils/inventoryUtils';

export const useProcessVehicles = (data) => {
	const { excludeModelsWithoutInventory, showAllModelsTab, displayStyle } =
		usePrefs();
	const inventoryCounts = useSelector(inventoryCountsSelector);
	const labels = useLabels();
	return useMemo(() => {
		let processedVehicles;
		// tilesCarousel always excludes zero-inventory vehicles per-tile,
		// so a body-style group with no in-stock models would render an
		// empty carousel if its tab stayed clickable -- drop the whole
		// group here too, same as excludeModelsWithoutInventory does, so
		// its tab never appears in the first place.
		if (
			(excludeModelsWithoutInventory === 'true' ||
				displayStyle === 'tilesCarousel') &&
			inventoryCounts &&
			Object.keys(inventoryCounts).length
		) {
			processedVehicles = filterVehiclesWithoutInventory(
				data,
				inventoryCounts
			);
		} else {
			processedVehicles = { ...data };
		}

		if (showAllModelsTab === 'true' && processedVehicles) {
			const allCars = groupUniqueVehicles(processedVehicles);
			const allLabel = labels.get('ALL');
			processedVehicles[allLabel] = [...allCars];
		}

		processedVehicles = addModelInv(processedVehicles, inventoryCounts);

		return processedVehicles;
	}, [
		data,
		inventoryCounts,
		excludeModelsWithoutInventory,
		displayStyle,
		labels,
		showAllModelsTab
	]);
};
